import { render, staticRenderFns } from "./periodEndorseForm.vue?vue&type=template&id=77aaec30&scoped=true&"
import script from "./periodEndorseForm.vue?vue&type=script&lang=js&"
export * from "./periodEndorseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77aaec30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77aaec30')) {
      api.createRecord('77aaec30', component.options)
    } else {
      api.reload('77aaec30', component.options)
    }
    module.hot.accept("./periodEndorseForm.vue?vue&type=template&id=77aaec30&scoped=true&", function () {
      api.rerender('77aaec30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/policy/entry/periodEndorseForm.vue"
export default component.exports